import React, {useEffect, useRef, useState} from 'react';
import {Button, Checkbox, Col, Divider, Layout, Modal, Row, Steps, Tooltip} from "antd";
import {Content} from "antd/es/layout/layout";
import img1 from "./imgs/Textura Birch.webp"
import img2 from "./imgs/Textura Black.webp"
import img3 from "./imgs/Textura Pine.webp"
import img4 from "./imgs/Textura Walnut.webp"
import './style.scss'
import bar1 from "./imgs/bar1.png"
import bar2 from "./imgs/bar2.png"
import {FeatureText} from "../Subscription/text";
import {ReactComponent as TickIcon} from "../Subscription/Tick icon.svg"
import {ReactComponent as InfoIcon} from "../Subscription/Information icon.svg"
import SubscriptionEnquiryModal from "./components/SubscriptionEnquiryModal";
import {CardElement, Elements, PaymentElement, useElements, useStripe} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from "./components/CheckoutForm";
import {post_api_pay_textura} from "../../portal/serverTemp";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(
    'pk_test_51Os5LSGQ0e0qnR9lr6IuCRPXYinxlaj2MjodtRtwNu7RDzyXe7YgpgbxidBAnI4Z3ogI1bE03RgRrQBns2hJRKUi00kQl5A6Hz'
);

const CrossIcon = () => {
    return (
        <div className={'cross-btn'}>x</div>
    )
}

const texturaIDs = {
    'black': 0,
    'birch': 1,
    'pine': 2,
    'walnut': 3
}
const Shopping = (props) => {
    const [isPayModalOpen, setIsPayModalOpen] = useState(false)
    const [cntBlack, setCntBlack] = useState(0)
    const [cntBirch, setCntBirch] = useState(0)
    const [cntPine, setCntPine] = useState(0)
    const [cntWalnut, setCntWalnut] = useState(0)
    const [curStep, setCurStep] = useState(0)
    const [total, setTotal] = useState(0)
    const [subFee, setSubFee] = useState(0)
    const [sub, setSub] = useState(null)
    const [purchaseIDs, setPurchaseIDs] = useState([])
    const [agreed, setAgreed] = useState(false)
    const [clientSecret, setClientSecret] = useState('')
    const [freeTrialDisplay, setFreeTrialDisplay] = useState(false)
    const [active, setActive] = useState(
        {
            'Standard': 1,
            'Advanced': 1,
            'Premium': 1
        }
    )
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        const sum = cntBirch + cntWalnut + cntPine + cntBlack
        setTotal(sum * 640 + sum * subFee)
        // Create arrays for each product type and fill them
        const birchIds = Array(cntBirch).fill(0);
        const blackIds = Array(cntBlack).fill(1);
        const pineIds = Array(cntPine).fill(2);
        const walnutIds = Array(cntWalnut).fill(3);

        // Combine all arrays into one
        const purchaseIDs = [...birchIds, ...blackIds, ...pineIds, ...walnutIds];

        setPurchaseIDs(purchaseIDs);
    }, [cntBirch, cntBlack, cntPine, cntWalnut, subFee]);
    return (
        <Layout>
            <Content style={{background: '#E8E8E8'}}>
                <Row className={'progress-bar'}></Row>
                <Row justify={"center"}

                     style={{
                         margin: '4rem 0 2rem 0'
                     }}>
                    {curStep === 0 ?
                        <div className="sp-image-container">
                            <img src={bar1}/>
                            <div className="clickable-area-right" onClick={() => setCurStep(1)}></div>
                        </div> :
                        <div className="sp-image-container">
                            <img src={bar2} style={{paddingTop: '1rem'}}/>
                            <div className="clickable-area-left" onClick={() => setCurStep(0)}></div>
                        </div>
                    }

                </Row>
                {curStep === 0 && <Row justify={"center"} className={'t-row'}>
                    <Col lg={5} className={'t-col'}>
                        <div className={'shop-pd-col'}>
                            <img className={'shop-exp-image'} src={img1}/>
                            <p className={'shop-pd-name'}>Birch - £640</p>
                        </div>
                        <div className={'shop-select-div'}>
                            <div className={'shop-select-op'}
                                 onClick={() => cntBirch > 0 && setCntBirch(cntBirch - 1)}
                            >-
                            </div>
                            {cntBirch}
                            <div className={'shop-select-op'}
                                 onClick={() => setCntBirch(cntBirch + 1)}
                            >+
                            </div>
                        </div>
                    </Col>
                    <Col lg={5} className={'t-col'}>
                        <div className={'shop-pd-col'}>
                            <img className={'shop-exp-image'} src={img2}/>
                            <p className={'shop-pd-name'}>Black - £640</p>
                        </div>
                        <div className={'shop-select-div'}>
                            <div className={'shop-select-op'}
                                 onClick={() => cntBlack > 0 && setCntBlack(cntBlack - 1)}
                            >-
                            </div>
                            {cntBlack}
                            <div className={'shop-select-op'}
                                 onClick={() => setCntBlack(cntBlack + 1)}
                            >+
                            </div>
                        </div>
                    </Col>
                    <Col lg={5} className={'t-col'}>
                        <div className={'shop-pd-col'}>
                            <img className={'shop-exp-image'} src={img3}/>
                            <p className={'shop-pd-name'}>Pine - £640</p>
                        </div>
                        <div className={'shop-select-div'}>
                            <div className={'shop-select-op'}
                                 onClick={() => cntPine > 0 && setCntPine(cntPine - 1)}
                            >-
                            </div>
                            {cntPine}
                            <div className={'shop-select-op'}
                                 onClick={() => setCntPine(cntPine + 1)}
                            >+
                            </div>
                        </div>
                    </Col>
                    <Col lg={5} className={'t-col'}>
                        <div className={'shop-pd-col'}>
                            <img className={'shop-exp-image'} src={img4}/>
                            <p className={'shop-pd-name'}>Walnut - £640</p>
                        </div>
                        <div className={'shop-select-div'}>
                            <div className={'shop-select-op'}
                                 onClick={() => cntWalnut > 0 && setCntWalnut(cntWalnut - 1)}
                            >-
                            </div>
                            {cntWalnut}
                            <div className={'shop-select-op'}
                                 onClick={() => setCntWalnut(cntWalnut + 1)}
                            >+
                            </div>
                        </div>
                    </Col>
                </Row>}
                {curStep === 1 &&
                    <Row
                        justify={"center"}
                        style={{
                            columnGap: '6rem',
                            padding: '0 0 3rem 0'
                        }}
                    >
                        <Col className={'sub-option'} lg={6}
                             style={active.Standard === 0 ? {background: ' #D9D9D9', opacity: '0.5'} : {}}
                        >
                            <p className={'sub-opt-title'}>Standard</p>
                            <p className={'sub-opt-subtitle'}>Free</p>
                            <p className={'sub-opt-per-year'}
                                // style={{color: "white"}}
                            >
                                per year</p>

                            <Button className={'shop-sub-opt-btn'}
                                    onClick={() => {
                                        setActive({'Standard': 1, 'Advanced': 0, 'Premium': 0});
                                        setSubFee(0)
                                        setSub('Standard')
                                    }}
                                    disabled={total > 1280}
                            >
                                Standard
                            </Button>
                            <p className={'sub-opt-j-small-txt'}
                               style={{
                                   margin: '0 0 -1vh 0',
                                   cursor: "pointer",
                               }}
                               onClick={
                                   _ => setFreeTrialDisplay(!freeTrialDisplay)
                               }
                            >
                                or sign up for 30 day free trial
                            </p>
                            <p className={'sub-opt-small-title'}>Standard features:</p>
                            {FeatureText['Standard'].map((txtList, idx) => {
                                return (
                                    <div>
                                        <div className={'sub-features-div'}>
                                            <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span>
                                            <Tooltip title={txtList[1]}><InfoIcon/></Tooltip>
                                        </div>
                                        <Divider style={{
                                            marginTop: '-0.3vh'
                                        }}/>
                                    </div>
                                )
                            })}
                        </Col>
                        <Col className={'sub-option'} lg={6}
                             style={active.Advanced === 0 ? {background: ' #D9D9D9', opacity: '0.5'} : {}}
                        >
                            <div className={'sub-most-popular'}>
                                <p className={"sub-most-popular-h"}>Try free for 30 days</p>
                                <span className="sub-most-popular-text">
                                Upgrade from standard subscription for a month to explore new features
                                </span>
                            </div>
                            <p className={'sub-opt-title'}>Advanced</p>
                            <p className={'sub-opt-subtitle'}>£96</p>
                            <p className={'sub-opt-per-year'}>per year, per unit</p>
                            <Button className={'shop-sub-opt-btn'}
                                    onClick={() => {
                                        setActive({'Premium': 0, 'Standard': 0, 'Advanced': 1});
                                        setSubFee(100)
                                        setSub('Advanced')
                                    }}
                                    style={{marginBottom: '1rem'}}
                                    disabled={total > 6400}
                            >Try free for 30 days</Button>
                            <p className={'sub-opt-small-title'}>Advanced features:</p>
                            {FeatureText['Advanced'].map((txtList, idx) => {
                                return (
                                    <div>
                                        <div className={'sub-features-div'}>
                                            <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span>
                                            <Tooltip title={txtList[1]}><InfoIcon/></Tooltip>
                                        </div>
                                        <Divider style={{
                                            marginTop: '-0.3vh'
                                        }}/>
                                    </div>

                                )
                            })}
                        </Col>
                        <Col className={'sub-option'}
                             lg={6}
                             style={active.Premium === 0 ? {background: '#D9D9D9', opacity: '0.7'} : {}}
                        >
                            <p className={'sub-opt-title'}>Premium</p>
                            <p className={'sub-opt-subtitle'}>POA</p>
                            <p className={'sub-opt-per-year'}>per year</p>
                            <Button className={'shop-sub-opt-btn'}
                                    onClick={() => {
                                        setActive({'Premium': 1, 'Standard': 0, 'Advanced': 0});
                                        setSubFee(0)
                                        setSub('Premium')
                                    }}
                                    style={{marginBottom: '1rem'}}
                            >Premium</Button>
                            <p className={'sub-opt-small-title'}>Premium features:</p>
                            {FeatureText['Premium'].map((txtList, idx) => {
                                return (
                                    <div>
                                        <div className={'sub-features-div'}>
                                            <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span>
                                            <Tooltip title={txtList[1]}><InfoIcon/></Tooltip>
                                        </div>
                                        <Divider style={{
                                            marginTop: '-0.3vh'
                                        }}/>
                                    </div>
                                )
                            })}
                        </Col>
                    </Row>
                }
                {/*Order Summary Information Section*/}
                <p className={'shop-order-summary'} hidden={total === 0}>Order summary</p>
                <Row justify={"center"} gutter={[32, 32]} hidden={total === 0} style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Col lg={sub === null ? 15 : 12} className={'order-col'}>
                        {cntPine > 0 && <div className={'shop-pd-col'} style={{marginTop: '15px'}}>
                            <img src={img3} style={{width: '45%'}}/>
                            {/*<CrossIcon></CrossIcon>*/}
                            <p className={'shop-pd-name'}>Pine - £640 x {cntPine}</p>
                        </div>}
                        {cntBlack > 0 &&
                            <div className={'shop-pd-col'} style={{marginTop: '15px'}}>
                                <img src={img2} style={{width: '45%'}}/>
                                <p className={'shop-pd-name'}>Black - £640 x {cntBlack}</p>
                            </div>}
                        {cntBirch > 0 &&
                            <div className={'shop-pd-col'} style={{marginTop: '15px'}}>
                                <img src={img1} style={{width: '45%'}}/>
                                <p className={'shop-pd-name'}>Birch - £640 x {cntBirch}</p>
                            </div>}
                        {cntWalnut > 0 && <div className={'shop-pd-col'} style={{marginTop: '15px'}}>
                            <img src={img4} style={{width: '45%'}}/>
                            <p className={'shop-pd-name'}>Walnut - £640 x {cntWalnut}</p>
                        </div>}
                    </Col>
                    {sub === null && <Col lg={5} className={'order-col order-col-right'}>
                        <p className={'shop-txt-step-1-txt'}>
                            You have chosen {cntBirch + cntWalnut + cntPine + cntBlack} Textura digital canvases, with
                            the total shown below
                        </p>
                        <p className={'shop-txt-total'}>Total</p>
                        <p className={'shop-txt-pay-num'}>£{total}</p>
                        <p className={'shop-txt-step-1-txt'}>
                            Click the ‘Next’ button below to select your level of subscription
                        </p>
                    </Col>}
                    {sub !== null && <Col lg={8} className={'order-col order-col-right'}>
                        <p className={'shop-txt-step-2-top-txt'} style={{margin: '10px auto 18px 20px'}}>
                            <span
                                style={{fontWeight: '700'}}>Textura Pro Qty:</span> {cntBirch + cntWalnut + cntPine + cntBlack}
                        </p>
                        <p className={'shop-txt-step-2-top-txt'} style={{margin: '-20px auto 2px 20px'}}>
                            <span style={{fontWeight: '700'}}>Subscription type:</span> {sub==='Advanced'?
                        'Advanced  - 12 month subscription (billed after 30 days trial)':sub ==='Standard'?'Standard (Free)':'Premium'}
                        </p>
                        <Row style={{marginTop: '24px'}}>

                            <Col span={14} style={{margin: '58px auto 0 -36px'}} className={'shop-tc-col'}>
                                {sub === 'Standard' && freeTrialDisplay &&
                                    <p className={'shop-txt-j-f'}>You have selected a 30-day trial</p>
                                }
                                <Checkbox onChange={(e) => {
                                    console.log(`checked = ${e.target.checked}`);
                                    setAgreed(e.target.checked)
                                }}>
                                    <p className={'shop-txt-new-ds-btm'} style={{margin: '11px 0 -2px 0'}}>
                                        I accept the conditions of the 30 days free trial.
                                    </p>
                                    <p className={'shop-txt-new-ds-btm'}
                                       style={{
                                           fontWeight: '600',
                                           textDecoration: 'underline',
                                           cursor: 'pointer'
                                       }}
                                       onClick={_ =>
                                           window.open('http://192.168.1.140/proportal/ProPaymentAgreement', '_blank')
                                       }
                                    >
                                        Read the Vieunite Limited Terms & Conditions
                                    </p>
                                </Checkbox>
                            </Col>
                            <Col span={10} style={{marginTop: '11px'}}>
                                <p className={'shop-txt-new-ds-st'}>
                                    <span>Canvas total</span>
                                    <span>{(cntBirch + cntWalnut + cntPine + cntBlack) * 640}</span>
                                </p>
                                <p className={'shop-txt-new-ds-st'}>
                                    <span>Subscription total</span>
                                    <span>{subFee}</span>
                                </p>
                                <p className={'shop-txt-new-ds-st'}>
                                    <span>VAT @20%</span>
                                    <span>{(((cntBirch + cntWalnut + cntPine + cntBlack) * 640) / 1.2).toFixed(2)}</span>
                                </p>
                                <p className={'shop-txt-new-ds-st'}>
                                    <span>Total</span>
                                    <span>{(total + ((cntBirch + cntWalnut + cntPine + cntBlack) * 640) / 1.2).toFixed(2)}</span>
                                </p>
                            </Col>
                        </Row>
                    </Col>}

                </Row>
                <Row justify={"center"} className={'shop-step-row'}>
                    <Button
                        className={'shop-step-btn'}
                        onClick={() => {
                            if (curStep > 0) {
                                setCurStep(curStep - 1)
                            } else {
                                window.location.href = '/business/textura-pro'
                            }
                            setActive({'Premium': 1, 'Standard': 1, 'Advanced': 1});
                            setSub(null)
                        }}
                    >
                        Back
                    </Button>
                    <Button className={'shop-step-btn'}
                            onClick={() => {
                                if (sub !== 'Premium') {
                                    // eslint-disable-next-line default-case
                                    switch (curStep) {
                                        case 0:
                                            if (total > 1280) {
                                                setActive({'Premium': 1, 'Standard': 0, 'Advanced': 1})
                                            }
                                            if (total > 6400) {
                                                setActive({'Premium': 1, 'Standard': 0, 'Advanced': 0})
                                            }
                                            setCurStep(curStep + 1)
                                            break
                                        case 1://Able to pay now
                                            console.log(purchaseIDs, curStep)
                                            post_api_pay_textura('/business_purchase/texturas_purchase', {
                                                "textura_purchase_ids": purchaseIDs,
                                                "subscription_type": sub === 'Advanced' ? 1 : 0
                                            }).then((res) => {
                                                console.log(res)
                                                setClientSecret(res?.clientSecret)
                                            }).then(() => {
                                                setIsPayModalOpen(true)
                                            }).catch(error => console.log('error', error));
                                            break
                                    }


                                    var topBlueBar = document.querySelector('.progress-bar');
                                    topBlueBar.scrollIntoView();
                                } else {
                                    setIsModalOpen(true)
                                }
                            }}
                            disabled={(curStep === 0 && total === 0) ||
                                (curStep === 1 && sub === null) ||
                                (curStep === 1 && agreed === false) ||
                                sub === 'Premium'
                            }
                    >
                        {curStep === 0 ? 'Next' : 'Pay now'}
                    </Button>
                </Row>
                <SubscriptionEnquiryModal
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                />
            </Content>
            <Modal className={'portal-payment-modal'}
                   visible={isPayModalOpen}
                   onCancel={_ => setIsPayModalOpen(false)}
            >
                <Elements stripe={stripePromise} options={{
                    clientSecret: clientSecret,
                }}>
                    <CheckoutForm setsetIsPayModalOpen={setIsPayModalOpen}/>
                </Elements>
            </Modal>
        </Layout>
    )
}

export default Shopping;
